import { render } from "./AppNavigation.vue?vue&type=template&id=81ac0d3e"
import script from "./AppNavigation.vue?vue&type=script&lang=js"
export * from "./AppNavigation.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__